var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 27") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.7,18.2a1,1,0,0,1-.95-.68L7.3,4.16,5.55,9.42a1,1,0,0,1-.95.68H1a1,1,0,0,1,0-2H3.88L6.35.68a1,1,0,0,1,1.9,0L12.7,14l1.75-5.25a1,1,0,0,1,.95-.68H19a1,1,0,0,1,0,2H16.12l-2.47,7.42A1,1,0,0,1,12.7,18.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStream);
export default __webpack_public_path__ + "static/media/icon-stream.b0f110edf2e65ab5677032983a3380b9.svg";
export { ForwardRef as ReactComponent };